export default __webpack_public_path__ + "static/media/energie3.cf1e3646.jpg";